import { useState, useRef, useCallback } from 'react';
import { FeedbackData } from '../../types/chat.types';
import { useAppDispatch } from './redux';
import { submitFeedbackThunk } from '../../store/thunks/sessionThunks';

interface FeedbackModalState {
  traceId: string;
  reaction: 'thumbs-up' | 'thumbs-down';
}

export const useFeedbackModal = () => {
  const dispatch = useAppDispatch();
  const [feedbackModal, setFeedbackModal] = useState<FeedbackModalState | null>(null);
  const feedbackResetRef = useRef<(() => void) | null>(null);

  const handleFeedback = useCallback(
    (_messageId: string, traceId: string, isPositive: boolean, resetSelection: () => void) => {
      feedbackResetRef.current = resetSelection;
      setFeedbackModal({
        traceId,
        reaction: isPositive ? 'thumbs-up' : 'thumbs-down',
      });
    },
    [],
  );

  const handleFeedbackClose = useCallback(() => {
    feedbackResetRef.current?.();
    feedbackResetRef.current = null;
    setFeedbackModal(null);
  }, []);

  const handleFeedbackSubmit = useCallback(
    (feedbackData: FeedbackData) => {
      if (feedbackModal) {
        dispatch(submitFeedbackThunk({ traceId: feedbackModal.traceId, feedbackData }));
      }
      feedbackResetRef.current = null;
      setFeedbackModal(null);
    },
    [dispatch, feedbackModal],
  );

  return {
    feedbackModal,
    handleFeedback,
    handleFeedbackClose,
    handleFeedbackSubmit,
  };
};
